import { Shift, TrainShift, ScheduleTrain, TrainTimetableEntry } from '../common/train';
import { cloneDeep } from 'lodash-es';

/**
 * Parses train shifts for specified station and filters out the tasks
 * that doesn't concern the station
 */
export const getShiftsInTrainForStation = (
    trainShift: TrainShift,
    schedule: ScheduleTrain,
    station: string
  ): Shift[] => {
    // console.warn('trainShift', trainShift);
    // console.warn('schedule', schedule);
    // console.warn('station', station);
    return trainShift.shifts.map(shift => {
      const shiftWithOnlyStationTasks = cloneDeep(shift);
      // Stations which the train will pass. Remove duplicate entries (arrival / departure)
      const stations = schedule.timetable.reduce(
        (acc: string[], row: TrainTimetableEntry) =>
          acc[acc.length - 1] === row.station
            ? acc
            : [...acc, row.station],
        []
      );

      const tasksForStation = shift.tasks
        .filter(task => task.trainNumber === trainShift.trainNumber) // Use only tasks related to currentTrain
        .filter(task => {
          // Example:
          // stations = ['A', 'B', 'C'];
          // shift.fromStation = 'A';
          // shift.toStation = 'C';
          // station = 'B'
          // -> we need to know which stations the shift will pass

          const idxFrom = stations.indexOf(task.fromStation);
          const idxTo = stations.indexOf(task.toStation, idxFrom); // The toStation should be same station as fromStation or after it
          const taskStations = stations.slice(idxFrom, idxTo);

          const stationFoundFromThisTaskStations = taskStations.find(taskStation => taskStation === station);
          const stationWasFound = stationFoundFromThisTaskStations !== undefined;
          return stationWasFound;
        });

      shiftWithOnlyStationTasks.tasks = tasksForStation;
      // console.warn('shiftWithOnlyStationTasks', shiftWithOnlyStationTasks);
      return shiftWithOnlyStationTasks;
    });
  };
